import { configureStore } from "@reduxjs/toolkit";
import appCommonReducer from "./features/app-common-slice";

export const store = configureStore({
  reducer: {
    appCommon: appCommonReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
